export const LAYOUT_TAG_NAME = 'tm-bo-layout';
export const COMPANY_LAYOUT_TAG_NAME = 'tm-bo-company-layout';
export const COMPANY_USER_LAYOUT_TAG_NAME = 'tm-bo-company-user-layout';
